<template>
	<img src="@/assets/svg/header-profile.svg" />
</template>

<script>
export default {}
</script>

<style></style>
